import { Box, Typography } from '@mui/material';
import React from 'react';
import { ReactComponent as Play } from '../../assets/icons/Play.svg';
import Logo from '@components/Logo';
import { useNavigate } from 'react-router-dom';
import Paths from '@/routes/paths';
import { ONE_SEC, TIME_SEC_TO_REDIRECT } from '@/constant';
import useCandidate from '@authentication/hooks/useCandidate';

function SpaceComponent() {
  const [sec, setSec] = React.useState(TIME_SEC_TO_REDIRECT);
  const {
    setRecordChunksG,
    setPhotos,
    setVideo,
    setIsSplitPhotos,
    setCandidate,
    setVideoDuration,
  } = useCandidate();
  const navigate = useNavigate();
  React.useEffect(() => {
    setRecordChunksG([]);
    setVideo(undefined);
    setPhotos([]);
    setVideoDuration(0);
    setIsSplitPhotos(false);
    setCandidate(null);
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      if (sec === 0) {
        navigate(Paths.DashboardPage);
      }
      if (sec <= TIME_SEC_TO_REDIRECT) {
        setSec(sec - 1);
      }
    }, ONE_SEC);
    return () => {
      clearInterval(timer);
    };
  }, [sec]);

  return (
    <Box
      sx={{
        background: '#662B5C',
        height: '100vh',
        width: '100vw',
        paddingBlock: '5vh',
        '@media (min-width: 1024px) and (min-height: 1366px)': {
          minHeight: '10vh',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          gap: '56px',
          paddingInline: '20vw',
          paddingTop: '5vh',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '60px',
          }}
        >
          <Logo />
        </Box>
        <Box
          sx={{
            background: '#FAF2F7',
            // marginLeft: '20%',
            width: '100%',
            paddingTop: '56px',
            borderRadius: '4px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              marginInline: 'auto',
              height: '100%',
              width: '50%',
            }}
          >
            <Box sx={{ width: '80%', marginInline: '2rem' }}>
              <Box
                sx={{
                  height: '28px',
                  width: '100%',
                  borderRadius: '16px 16px 0px 0px',
                  background: '#E8E8E8',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center',
                    marginLeft: '1rem',
                  }}
                >
                  <div
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#0EABBC',
                      borderRadius: '50%',
                    }}
                  />
                  <div
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#D6584D',
                      borderRadius: '50%',
                    }}
                  />
                  <div
                    style={{
                      width: '8px',
                      height: '8px',
                      background: '#FFCE6E',
                      borderRadius: '50%',
                    }}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: ' 0px 0px 16px 16px',
                  backgroundColor: '#3AA05C',
                  minHeight: '20vh',
                  '@media (min-width: 1024px) and (min-height: 1366px)': {
                    minHeight: '10vh', // Change minimum height for tablets with 1024x1366 resolution
                  },
                }}
              >
                <Play />
              </Box>
            </Box>
            <Typography
              sx={{
                textAlign: 'center',
                fontFamily: 'Inter',
                fontSize: '24px',
                fontStyle: 'normal',
                fontWeight: '800',
                marginBlock: '1rem',
                background:
                  'linear-gradient(90deg, #A03A7E 0%, #9B397B 37.57%, #662B5C 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                lineHeight: '36px',
              }}
            >
              Bravo ! Tout s’est bien passé !
            </Typography>
          </Box>
          <Typography
            sx={{
              color: '#1D1D1D',
              textAlign: 'center',
              fontFamily: 'Inter',
              fontSize: '16px',
              fontStyle: 'normal',
              fontWeight: '400',
              lineHeight: '28px',
              marginBottom: '48px',
              marginInline: '56px',
            }}
          >
            Votre CV Vidéo est maintenant enregistré. Un conseiller ou hôtesse
            Triangle Store RH fera le nécessaire pour le suivi de votre
            candidature.
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <Typography
          sx={{
            color: '#EDC2E2',
            textAlign: 'center',
            fontFamily: 'Inter',
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: '400',
            lineHeight: '24px',
            marginTop: '48px',
          }}
        >
          Redirection dans {sec} ...
        </Typography>
      </Box>
    </Box>
  );
}

export default SpaceComponent;
